import React from 'react';
import PropTypes from 'prop-types';

import {Dropdown} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CARET_DOWN__16} from '@homeaway/svg-defs/lib/defs/CARET_DOWN__16';
import './Help.less';

export class Help extends React.Component {
    static propTypes = {
        openLinksInNewWindow: PropTypes.bool,
    };

    renderItem = (item, index) => {
        if (item.cssClass === 'divider') {
            return (
                <li className="divider" key={index} />
            );
        }

        if (item.cssClass === 'nav-header') {
            return (
                <li className="Dropdown__header" key={index}>{item.text}</li>
            );
        }

        let rel;
        let target;

        if (this.props.openLinksInNewWindow) {
            rel = 'noopener noreferrer';
            target = '_blank';
        }

        return (
            <li key={index} role={'none'}>
                <a data-bypass="true" href={item.link} rel={rel} role={'menuitem'} target={target}>{item.text}</a>
            </li>
        );
    }

    render() {
        let {items, label} = this.props;

        if (!items) {
            return null;
        }

        const id = 'site-header__help';

        const toggle = (
            <button
                aria-expanded="false"
                aria-haspopup="true"
                className="site-header-nav__toggle Dropdown__toggle"
                id={id}
            >
                {label} <SVGIcon className="Dropdown__toggle-icon Dropdown__toggle-icon--header" inlineFlex markup={CARET_DOWN__16}/>
            </button>
        );

        return (
            <Dropdown className="site-header-nav__dropdown" customToggle={toggle} dropdownRight id={id} label={this.props.label}>
                {this.props.items.map(this.renderItem)}
            </Dropdown>
        );
    }
}
